<template>
  <i18n
    v-if="id"
    path="parent-reference-line-item-id.description"
    :tag="tag"
  >
    <span id="parent-reference-line-item-id">{{ label }}</span>
  </i18n>
</template>
<script>
import { mapGetters } from 'vuex'
import { GET_REWARD_LINK_PARENT_REFERENCE_LINE_ITEM_ID } from '@/store/get-types'

export default {
  name: 'ParentReferenceLineItemId',
  props: {
    tag: {
      type: String,
      default: 'p'
    }
  },
  computed: {
    ...mapGetters({
      id: GET_REWARD_LINK_PARENT_REFERENCE_LINE_ITEM_ID
    }),
    label () {
      return this.$t('parent-reference-line-item-id.label', { id: this.id })
    }
  }
}
</script>
<style lang="scss" scoped>
#parent-reference-line-item-id {
  font-weight: bold;
  font-style: italic;
}
</style>
